import { render, staticRenderFns } from "./Separate.vue?vue&type=template&id=5112435e&scoped=true&"
import script from "./Separate.vue?vue&type=script&lang=js&"
export * from "./Separate.vue?vue&type=script&lang=js&"
import style0 from "./Separate.vue?vue&type=style&index=0&id=5112435e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112435e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
